import firebase from "firebase/compat/app";
import { HolidayCollection } from "types";

/**
 * holiday Collectionのデータをバインディングする関数です。
 * @param setState useState関数のsetメソッド
 * @returns
 */
export const HolidayOnSnapShot = (
  setState: React.Dispatch<React.SetStateAction<HolidayCollection[] | null>>
) => {
  return firebase
    .firestore()
    .collection("holiday")
    .onSnapshot(
      docs => {
        const collectionList = docs.docs.map(
          doc => ({ ...doc.data(), id: doc.id } as HolidayCollection)
        );
        setState(collectionList);
      },
      (err: any) => console.log(err)
    );
};
